/* eslint-disable @nicejob/snake-case */
export enum Role {
    // User Roles
    OWNER = 'OWNER',
    MANAGER_PLUS_PAYMENT = 'MANAGER_PLUS_PAYMENT',
    MANAGER = 'MANAGER',
    TEAM_MEMBER = 'TEAM_MEMBER',

    // Admins
    ADMIN = 'ADMIN',
    SUPERADMIN = 'SUPERADMIN',

    // States
    DELETE = 'DELETE',
    EDIT = 'EDIT',

    // No User Access
    NO_ACCESS = 'NO_ACCESS',
}
